import { TransferPlace } from '../../lib/types/models/transfer/transfer-place'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderTransfers(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.getTransfers.url, { id }))
    .get<TransferPlace[]>()
}
